import React, { useState, useEffect } from "react";
import s from "./CreateGame.module.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import Grid from "@mui/material/Grid"
import Tooltip from "@mui/material/Tooltip"
import TextField from "@mui/material/TextField"
import Box from "@mui/material/Box"
import Switch from "@mui/material/Switch"
import Button from "@mui/material/Button"
import CircularProgress from "@mui/material/CircularProgress"
import FormControl from "@mui/material/FormControl"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddPhotoAlternateRoundedIcon from "@mui/icons-material/AddPhotoAlternateRounded";
import { useTranslation } from "react-i18next";
import gamesService from "../../../../api/games/GamesService";
import useTranslationException from "../../../../helpers/exceptions";
import { useNotificationContext } from "../../../Notifications/CustomNotifications";

// ======================= | CREATE GAME | ====================================

function CreateGame({ edit, setEdit, getGames }) {
  const navigate = useNavigate();
  const notification = useNotificationContext();
  const { textColor } = useSelector((state) => state.local);
  const { t, i18n } = useTranslation();
  const showExpetion = useTranslationException(t, i18n);
  const lottery = useSelector((state) => state.gamma.raffleLotteries)[0];
  const organizationNoa = useSelector((state) => state.gamma.noaOrganization);

  const [loading, setLoading] = useState(false);
  const [infoImage, setInfoImage] = useState({
    format: "",
    size: "",
  });

  const [allGames, setAllGames] = useState([]);
  const [mode, setMode] = useState(
    edit.status ? edit.game?.modality?.mode?.name : "INSTANTANEO",
  );
  const [form, setForm] = useState({
    id: edit.status ? edit.game.id : null,
    game: {
      id: edit.status ? edit.game.modality.game.id : null,
      name: edit.status ? edit.game.modality.game.name : "",
      image: edit.status ? edit.game.modality.game.image : "",
      instant: edit.status ? edit.game.modality.game.instant : true,
      organization: organizationNoa,
    },
    gameOffer: {
      enabled: edit.status ? edit.game.enabled : false,
      owner: edit.status ? edit.game.owner : true,
      organizationId: organizationNoa.id
    },
  });

  useEffect(() => {
    if (!allGames.length) {
      gamesService
        .getExistgames()
        .then((res) => setAllGames(res.content))
        .catch((error) => {
          notification.error("Error ep", error.message);
        });
    }
  }, [allGames]);

  const modos = [
    {
      id: 1,
      name: "PREIMPRESO",
    },
    {
      id: 2,
      name: "INSTANTANEO",
    },
  ];

  const isAcceptableImage = (format, size) => {
    return (format || "").trim().startsWith("image");
  };

  const handleChangeImage = (e) => {
    const format = e.target.files[0].type;
    const size = e.target.files[0].size / 1024;
    if (isAcceptableImage(format, size)) {
      setInfoImage({ format: format, size: size.toFixed(2) + "KB" });

      Array.from(e.target.files).forEach((file) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const base64 = reader.result;
          setForm({
            ...form,
            game: {
              ...form.game,
              image: base64,
            },
          });
          Swal.fire({
            icon: "success",
            title: t("imageUpload"),
            showConfirmButton: false,
            timer: 1500,
          });
        };
      });
    } else {
      Swal.fire({
        icon: "error",
        title: t("imageUploadError"),
        showConfirmButton: true,
      });
    }
  };

  /**
   * This function format the current date as required
   *
   * @returns The current date with this format "yyyy-mm-dd"
   * */
  const currentDate = () => {
    const current = new Date();

    const year = current.getFullYear();
    const month = String(current.getMonth() + 1).padStart(2, "0");
    const day = String(current.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  const handleSubmit = () => {
    if (form?.game?.name?.length >= 3) {
      Swal.fire({
        title: t("creatingGame"),
        didOpen: () => {
          Swal.showLoading();
        },
      });
      let modeToSend = modos.find((i) => i.name === mode);
      let isInstant = modeToSend.name === "INSTANTANEO";
      const payload = {
        gameOffer: {
          id: form.game.id,
          enabled: form.gameOffer.enabled,
          owner: form.gameOffer.owner,
          game: {
            id: form.game.id,
            name: form.game.name,
            externalId: null,
            image: form.game.image,
            instant: isInstant,
            lottery: lottery,
            organization: organizationNoa,
            mode: modeToSend,
            dateCreated: currentDate()
          }
        },
        game: {
          id: form.game.id,
          name: form.game.name,
          externalId: null,
          image: form.game.image,
          instant: isInstant,
          lottery: lottery,
          organization: organizationNoa,
          mode: modeToSend,
          dateCreated: currentDate()
        },
        mode: modeToSend
      };
      gamesService
        .addGames(payload)
        .then((res) => {
          const { id, ...objToCreate } = {
            ...form,
            game: res,
            mode: modeToSend,
          };
          getGames();
          Swal.fire({
            icon: "success",
            title: t("gameCreated"),
            showConfirmButton: false,
            timer: 1500,
          });
          navigate("../juegos");
        })
        .catch((e) => {
          showExpetion.showErrorModalForServiceException(
            e,
            { icon: "warning" },
            t("anErrorOccurred,TryAgain"),
            t("sorryErrorOcurred"),
          );
          setLoading(false);
        });
    } else {
      Swal.fire({
        icon: "error",
        title: t("insertName"),
      });
    }
  };

  const handleEdit = () => {
    if (form?.game?.name?.length >= 3) {
      setLoading(true);
      let modeToSend = modos.find((i) => i.name === mode);
      const payload = {
        gameOffer: {
          id: form.game.id,
          enabled: form.gameOffer.enabled,
          owner: form.gameOffer.owner,
          mode: modeToSend,
          game: {
            id: form.game.id,
            name: form.game.name,
            externalId: null,
            image: form.game.image,
            instant: form.game.instant,
            lottery: lottery,
            organization: organizationNoa,
            mode: modeToSend,
            dateCreated: currentDate()
          }
        },
        game: {
          id: form.game.id,
          name: form.game.name,
          externalId: null,
          image: form.game.image,
          instant: form.game.instant,
          lottery: lottery,
          organization: organizationNoa,
          mode: modeToSend,
          dateCreated: currentDate()
        }
      };
      gamesService
        .editGames(payload)
        .then((res) => {
          if (!res?.id) {
            Swal.fire({
              icon: "error",
              title: t("errorNameGames"),
              text: t("errorGames"),
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
            getGames();
            Swal.fire({
              icon: "success",
              title: t("gameEdited"),
              showConfirmButton: false,
              timer: 1500,
            })
              .then(() => {
                // dispatch(replaceGameOffers(res))
                setEdit({ game: {}, status: false });
                setLoading(false);
                navigate("../juegos");
              })
              .catch((error) => {
                setLoading(false);
                notification.error("Error ep", error.message);
              });
          }
        })
        .catch((e) => {
          showExpetion.showErrorModalForServiceException(
            e,
            { icon: "warning" },
            t("anErrorOccurred,TryAgain"),
            t("sorryErrorOcurred"),
          );
          setLoading(false);
        });
    } else {
      Swal.fire({
        icon: "error",
        title: t("insertName"),
      });
    }
  };

  const decodeImageSizeAndType = (base64) => {
    let base64Content = base64.split(";base64,").pop();
    let decodeData = atob(base64Content);
    let imageSizeBytes = decodeData.length;
    let imageSizeInKB = (imageSizeBytes / 1024).toFixed(3) + " KB";
    let imageSize = imageSizeInKB;
    let imageType = base64.split(";")[0].split(":")[1];
    return {
      size: imageSize,
      type: imageType,
    };
  };

  useEffect(() => {
    if (form.game.image) {
      let info = decodeImageSizeAndType(form.game.image);
      setInfoImage({ format: info.type, size: info.size });
    }
  }, []);

  return (
    <Grid container className={s.container}>
      <Grid item xs={10} className={s.titleContainer}>
        <ArrowBackIcon
          sx={{
            color: "primary.main",
            fontSize: "2rem",
            opacity: loading ? 0 : 1,
          }}
          onClick={() => {
            setEdit({ game: {}, status: false });
            navigate(-1);
          }}
          className={s.arrow}
        />
        <h4>
          {" "}
          {edit.status ? `${t("editForm")}` : `${t("creationFormGames")}`}{" "}
        </h4>
      </Grid>

      <Grid item container xs={11} className={s.form}>
        <Grid item container xs={11} className={s.main}>
          <Grid item xs={2} className={s.image}>
            <Grid item container xs={11} className={s.switch}>
              <p
                className={s.titleinput}
              >{`${t("game")} ${form.gameOffer.enabled ? t("active") : t("inactive")}`}</p>
              <Switch
                checked={form.gameOffer.enabled}
                onChange={() => {
                  const gameOfferChange = form.gameOffer;
                  gameOfferChange.enabled = !gameOfferChange.enabled;
                  setForm({ ...form, gameOffer: gameOfferChange });
                }}
              />
            </Grid>
            {form?.game?.image ? (
              <>
                <Tooltip title="Logo de juego" placement="top">
                  <img
                    src={form.game.image}
                    alt="logo"
                    className={s.imageIcon}
                  />
                </Tooltip>
                <label htmlFor="raised-button-file">
                  <Box
                    className={s.editButton}
                    sx={{ backgroundColor: "primary.main", color: textColor }}
                  >
                    {t("edit")}
                  </Box>
                </label>
              </>
            ) : (
              <Tooltip title="Agregar Logo">
                <label htmlFor="raised-button-file">
                  <AddPhotoAlternateRoundedIcon
                    className={s.addImageIcon}
                    sx={{ color: "primary.main" }}
                  />
                </label>
              </Tooltip>
            )}
            {infoImage.format ? (
              <Grid item xs={11}>
                <p style={{ fontSize: "1rem", fontWeight: 300 }}>
                  {t("format")}: {infoImage.format}
                </p>
                <p style={{ fontSize: "1rem", fontWeight: 300 }}>
                  {t("size")}: {infoImage.size}
                </p>
              </Grid>
            ) : null}
          </Grid>
          <Grid item xs={8} className={s.inputs}>
            <Grid item xs={12} className={s.inputItem}>
              <p className={s.titleinput}>{t("name")} *</p>
              <TextField
                sx={{ width: "80%" }}
                placeholder="Ingresar nombre..."
                variant="outlined"
                value={form.game.name}
                onChange={(e) =>
                  setForm({
                    ...form,
                    game: { ...form.game, name: e.target.value },
                  })
                }
              />
            </Grid>
            <Grid item xs={12} className={s.inputItem}>
              <p className={s.titleinput}>{t("modality")}</p>
              <FormControl sx={{ width: "80%" }}>
                <Select
                  value={mode}
                  onChange={(e) => setMode(e.target.value)}
                  disabled={edit?.status}
                >
                  {modos.map((item, i) => (
                    <MenuItem key={i} value={item.name}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} className={s.inputItem}>
              <Button
                disabled={loading}
                variant="contained"
                className={s.submit}
                onClick={edit.status ? handleEdit : handleSubmit}
              >
                {loading ? (
                  <CircularProgress />
                ) : edit.status ? (
                  `${t("saveChanges")}`
                ) : (
                  `${t("add")} ${t("game")}`
                )}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <input
        type="file"
        style={{ display: "none" }}
        onChange={(e) => handleChangeImage(e)}
        id="raised-button-file"
        accept="image/*"
      />
    </Grid>
  );
}

export default CreateGame;
